import { EnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { AiChatEffects, AiChatFeature } from '@qtek/libs/store';

/**
 * Configuration for AI Chat standalone components
 */
export const AI_CHAT_PROVIDERS: EnvironmentProviders[] = [
  provideState(AiChatFeature),
  provideEffects([AiChatEffects]),
];
